import { useEffect, useState } from "react"
import { useSelector } from "react-redux"

import { visibleDocumentVersions, extractDeleteReason } from "../../../../../lib/docs"
import { formatDateLocal } from "../../../../../lib/script"
import { practicesOptions, procoDocsDocumentTypesOptions } from "../../../../../lib/systemData"
import VerifiyDocument from "./VerifiyDocument"
import DocumentsTabListItemControls from "./DocumentsTabListItemControls"
import DocumentActions from "./controls/DocumentActions"
import RestoreProcoDocument from "./RestoreProcoDocument"
import HardDeleteProcoDocument from "./HardDeleteProcoDocument"
import { changeWordingForWC } from "../../../../../lib/misc"

import classes from './DocumentsTabListItem.module.css'
import DisplayBoxRight from "../../../../fragments/DisplayBoxRight"
import EditDocument from "../documents/EditDocument"
import DocumentEditable from "./DocumentEditable"
import { procoDocsFunctions } from "../../../../../lib/procoDocs"

const DocumentsTabListItem = ({data, secondary, isOlder, parent, updatePermission, deletePermission, isDeleted = false, restorePermission, hardDeletePermission}) => {
    const activeCase = useSelector(state => state.case.activeCase) 
    const [showRelatedFiles, setShowRelatedFiles] = useState(false)
    const [isEditing, setIsEditing] = useState(false)

    const [practicesMultipleDefaultSelectionString, setPracticesMultipleDefaultSelectionString] = useState(null)

  
    const showRelatedFilesHandler = () => {
        setShowRelatedFiles(prevState => prevState = !prevState)
    }

    let practices = practicesOptions()
    useEffect(() => {
        let practicesString = ''
        if (practices && data.practices) {    
            data.practices.forEach(element => {
                if (element != 'all') {
                    let vals = practices.find(item => item.value == element)           
              
                    practicesString = practicesString ? (practicesString + ', ' + vals?.label) : vals?.label
                } else {
                    practicesString = element
                }

            });        
            setPracticesMultipleDefaultSelectionString(practicesString)
        }

    }, [data])

    function setIsEditingHandler(value) {
        setIsEditing(value)
    }
    function cancelEditFileHandler() {
        setIsEditing(false)
    }

    const visibleVersions = visibleDocumentVersions(data)
    const deleteReason = isDeleted ? extractDeleteReason(data) : null

    return <>
        <tr className={`${(showRelatedFiles || secondary) ? classes.item_opened : ''} ${secondary ? classes.secondary : ''} ${isDeleted ? classes.deleted_row : ''} ${!isDeleted && procoDocsFunctions.isDocumentNotViewed(data) ? classes.not_viewed : ''}`}>
            {/* name and controls  */}
            <td>  
                <div className={classes.name_container_outer}>
                    {visibleVersions.length > 0 && <div className={classes.has_previous_files}>
                        <button onClick={showRelatedFilesHandler} className={showRelatedFiles ? classes.button_active : ''}><i className="ti ti-chevron-right"></i></button>                         
                    </div>}
                    <div className={classes.name_container}>
                        <div>
                            {data.file_name}
                            {visibleVersions.length > 0 && <div className={classes.prev_details}>{visibleVersions.length} more previous version{visibleVersions.length == 1 ? '' : 's'}</div>}
                        </div>
                        {!isDeleted && <DocumentsTabListItemControls item={data} isPrevious={secondary} parent={parent}/>}
                    </div>
                </div>    
            </td>

            {/* created at  */}
            <td>
                <DisplayBoxRight>
                    {data.created_at && <>{formatDateLocal(data.created_at)}</>}
                </DisplayBoxRight>
            </td>

            {/* user name  */}
            <td>
                {/* {data.added_by && data.added_by} */}
                {data.added_by_info && <>
                    {data.added_by_info.name}
                    {/* {data.added_by_info.law_firm_name && <div>
                        <strong>{data.added_by_info.law_firm_name}</strong>    
                    </div>} */}
                </>}
            </td>

            {!isOlder && !isDeleted && <>
                <td>{data.source}</td>

                {!isEditing && <>
                    {/* type  */}
                    <td>
                        {data.procodocs_document_type_id && <>{procoDocsDocumentTypesOptions()?.find(item => item.value == data.procodocs_document_type_id)?.label  == 'HIPAA' ? changeWordingForWC(activeCase, 'HIPAA', 'WC-207') : procoDocsDocumentTypesOptions()?.find(item => item.value == data.procodocs_document_type_id)?.label}</>}
                    </td>

                    {/* practice --- this is available only if the type is practice  */}
                    <td className={practicesMultipleDefaultSelectionString == 'all' ? classes.all_practices : ''}>
                        {practicesMultipleDefaultSelectionString ? practicesMultipleDefaultSelectionString : '-'}
                    </td>

                    {/* is viewed  */}
                    <td>
                        {data.is_viewed ? <div><i className="ti ti-checks"></i> Yes</div> : <div className={classes.cell_not_viewed}><i className="ti ti-x"></i> No</div>}
                    </td>

                    {/* is verified  */}
                    <td>
                        {data.is_verified ? <div><i className="ti ti-checks"></i> Yes</div> : <VerifiyDocument  documentId={data.id} type="viewed"><i className="ti ti-check"></i> Verify</VerifiyDocument>}
                    </td>

                    {/* update controls  */}
                    <td>
                        {!secondary && (updatePermission || deletePermission) && <div className={classes.controls}>
                            <DocumentActions item={data} deletePermission={deletePermission} hardDeletePermission={hardDeletePermission}/>
                            {updatePermission && <EditDocument document={data} setIsEditingHandler={setIsEditingHandler} isEditing={isEditing}/>}
                        </div>}
                    </td>
                </>}

                {isEditing && !isDeleted && <DocumentEditable data={data} isEditing={data} cancelEditFile={cancelEditFileHandler}/>}
            </>}
            {isDeleted && <>
                <td>{data.source}</td>
                <td>
                    {data.procodocs_document_type_id && <>{procoDocsDocumentTypesOptions()?.find(item => item.value == data.procodocs_document_type_id)?.label}</>}
                </td>
                <td>{practicesMultipleDefaultSelectionString ? practicesMultipleDefaultSelectionString : '-'}</td>
                <td colSpan={2}>
                    <div>
                        {data.deleted_at && <>Deleted {formatDateLocal(data.deleted_at)}</>}
                        {data.deleted_by_user?.name && <> by {data.deleted_by_user.name}</>}
                    </div>
                    {deleteReason && (
                        <div className={classes.deleted_reason}>Reason: {deleteReason}</div>
                    )}
                </td>
                <td>
                    <div className={classes.controls}>
                        {restorePermission && data.can_restore && <RestoreProcoDocument document={data} />}
                        {hardDeletePermission && data.can_hard_delete_file && <HardDeleteProcoDocument document={data} />}
                    </div>
                </td>
            </>}
            {isOlder && !isDeleted && <>
                <td>{data?.source}</td>
                <td colSpan={5}></td>
            </>}
        </tr>

        {showRelatedFiles && visibleVersions.length > 0 && visibleVersions.map(item => (
            <DocumentsTabListItem key={item.id} data={item} secondary={true} isOlder={true} parent={data}/>
        ))}
    </>
}

export default DocumentsTabListItem